import { defineMessages } from 'react-intl'

const cancellationPolicyTimelineMessages = defineMessages({
  modalTitle: {
    id: '36upQ7Iz8R4ndlEZX5H8',
    defaultMessage: 'Cancellation policy',
    description: 'Title of the modal that shows a hotel rate cancellation policy as a timeline',
  },
})

export default cancellationPolicyTimelineMessages
